// React
import { forwardRef } from "react"

// UI
import { classNames } from "@/lib/ui"

// Types
import { InputProps } from "@/components/form-controls/Input"

export const TextInput = forwardRef<HTMLInputElement, InputProps>(
	(
		{ className = "", classNameWrapper = "", hasError, showIcon, ...props },
		ref,
	) => {
		return (
			<input
				type={props.type ?? "text"}
				ref={ref}
				{...props}
				className={classNames(
					"appearance-none",
					showIcon === "bs-currency-euro" && "pl-8", // Padding left Because of the euro sign
					"border",
					hasError ? `border-red-300` : `border-gray-300`,
					hasError && `text-red-600`,
					"rounded-md shadow-sm",
					"placeholder-gray-400",
					"focus-within:text-dark focus:outline-none",
					hasError ? `focus:ring-red-500` : `focus:ring-primary-500`,
					hasError
						? `focus:border-red-500`
						: `focus:border-primary-500`,
					"text-sm disabled:bg-gray-100",
					className,
				)}
			/>
		)
	},
)

TextInput.displayName = "TextInput"
